module.exports = __webpack_public_path__ + "img/USC_Pharmacy_logo_horizontal_CMYK_2C.4f6d1ad8.jpg";